module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outputer",
    class: [_vm.fullscreen ? 'fullscreen' : '', _vm.preview ? 'preview' : '', _vm.theme],
    domProps: {
      "innerHTML": _vm._s(_vm.ripeTxt)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac847d2","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/outputer.vue
// module id = 361
// module chunks = 0